var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Dots = function Dots(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 512 512' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M448.046 191.984c-35.337 0-64.016 28.647-64.016 64.016s28.679 64.015 64.015 64.015c35.337 0 64.015-28.647 64.015-64.016s-28.678-64.016-64.015-64.016zm-192.046 0c-35.337 0-64.016 28.647-64.016 64.016s28.679 64.015 64.016 64.015 64.015-28.647 64.015-64.016-28.679-64.016-64.016-64.016zm-192.047 0C28.616 191.984-.063 220.631-.063 256s28.679 64.015 64.016 64.015 64.016-28.647 64.016-64.016-28.679-64.016-64.016-64.016z'
      })
    )
  );
};
/*eslint-enable */

export default Dots;
//# sourceMappingURL=Dots.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Dots.js